import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './styles.css';

import {
  getExercisesByDayAndWeek,
  copyDay,
  copyWeek,
  clearMessages
} from '../../../redux/slices/admin/dragSlice';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

const CopyExerciseModal = ({ isOpen, handleClose, isCopyingWeek, availableWeeks, availableDays, selectedDayData, selectedWeekData, selectedProgram }) => {
  const dispatch = useDispatch();
  const [selectedWeek, setSelectedWeek] = useState('');
  const [selectedDay, setSelectedDay] = useState('');
  const [weeks, setWeeks] = useState([]);
  const [days, setDays] = useState([]);

  const isCopySuccess = useSelector(state => state.drag.isCopySuccess); 
  const isLoading = useSelector(state => state.drag.isLoading); 

  useEffect(() => {
    if (isOpen) {     
      setWeeks(availableWeeks);
      handleWeekChange();     
    }
  }, [isOpen, availableWeeks, availableDays, isCopyingWeek]);

  const handleWeekChange = () => {
    const selectedWeek = document.getElementById('weekSelect').value;
    setSelectedWeek(selectedWeek);
    const week = availableWeeks.find(week => week.week_number === Number(selectedWeek));
    setDays(week ? week.days : []);
  };

  // Handle day change
  const handleDayChange = (e) => {
    setSelectedDay(e.target.value);
  };

  const handleSubmitConfirm = () => {
    confirmAlert({
      title: 'Confirm Copy',
      message: 'Are you sure you want to continue copying? Existing exercises in destination will be replaced.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => handleSubmit()
        },
        {
          label: 'No',
          onClick: () => {}
        }
      ]
    });
  }

  /**useEffect(() => {
    if (isCopySuccess) {
      handleClose();
      dispatch(clearMessages());
       dispatch(getExercisesByDayAndWeek({
        'day_number': selectedDay,
        'week_number': selectedWeek,
        'training_program_id': selectedProgram.id,
      }));
    }
  }, [isCopySuccess, handleClose]);**/

  useEffect(() => {
    if (!isCopySuccess) return;

    handleClose();

    setTimeout(() => {
      if (!isCopyingWeek) { // ✅ only fetch if day copy
        dispatch(getExercisesByDayAndWeek({
          day_number: selectedDay,
          week_number: selectedWeek,
          training_program_id: selectedProgram.id,
        }));
      }
      dispatch(clearMessages());
    }, 300);

  }, [isCopySuccess]);


  const handleSubmit = () => {
    if (isCopyingWeek) {
      var p1 = {'training_program_id':selectedProgram.id, 'selected_week_number':selectedWeekData.week_number, 'new_week_number':selectedWeek}
      dispatch(copyWeek(p1));
    } else {
      var p2 = {'training_program_id':selectedProgram.id, 'week_number':selectedWeekData.week_number, 'selected_day_number':selectedDayData.day_number, 'new_day_number':selectedDay, 'new_week_number':document.getElementById('weekSelect').value}
      dispatch(copyDay(p2));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal fade show copy-exercise-modal" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="modal-title">Copy Exercises</h5>
                 <button className="close" style={{ fontSize: '40px' }} onClick={handleClose}>&times;</button>
            </div>
            <div className="modal-body">
              
                <div className="form-group">
                  <label htmlFor="weekSelect">Select Week</label>
                  <select
                    id="weekSelect"
                    value={selectedWeek}
                    onChange={handleWeekChange}
                    className="form-control"
                    required
                  >
                    <option value="" disabled>Select a Week</option>
                    {weeks.map((week) => (
                      // If isCopyingWeek, exclude the selected week from the options
                      (!isCopyingWeek || week.week_number !== selectedWeekData?.week_number) && (
                        <option key={week.week_number} value={week.week_number}>
                          Week {week.week_number}
                        </option>
                      )
                    ))}
                  </select>
                </div>

                {/* Select Day Dropdown (Only shown if copying a specific day) */}
                {!isCopyingWeek && (
                  <div className="form-group">
                    <label htmlFor="daySelect">Select Day</label>
                    
                    <select
                      id="daySelect"
                      value={selectedDay}
                      onChange={handleDayChange}
                      className="form-control"
                      required
                    >
                      <option value="" disabled>Select a Day</option>
                      {isOpen && selectedWeek && selectedWeekData && days.map((day) => {
                        if (selectedWeek == selectedWeekData?.week_number) {
                          if (day.day_number != selectedDayData?.day_number) {
                            return (
                              <option key={day.day_number} value={day.day_number}>
                                Day {day.day_number}
                              </option>
                            );
                          }
                        } else {
                          return (
                            <option key={day.day_number} value={day.day_number}>
                              Day {day.day_number}
                            </option>
                          );
                        }
                        return null;
                      })}
                    </select>
                  </div>
                )}

                <div className="modal-footer">
                   <button type="submit" onClick={handleSubmitConfirm} className="btn btn-create w-100" disabled={isLoading}>
                {isLoading ? 'Copying...' : 'Copy Exercise'}
              </button>
                </div>
          
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CopyExerciseModal;